export default from './search-input';



// WEBPACK FOOTER //
// ./app/containers/search-input/index.js